<template>

  <h2 tabindex="0">{{headerText}}</h2>

  <RouterLinkButton tabindex="0" aria-label="Go back to the previous page" title="Go back to the previous page" mode="backButton"></RouterLinkButton>

  <PersonInfoComponent v-if="myPersonInfo != null" :person-object="myPersonInfo">
    <template v-slot:footer>
        <span tabindex="0">See the options below to edit this person's arming, security, and documents.</span>
      
    </template>
  </PersonInfoComponent>

  <PersonWeaponTable v-if="myPersonInfo != null" :person-id="personId"></PersonWeaponTable>
  
  <EditPersonForm v-if="myPersonInfo != null" :person-id="personId"></EditPersonForm>

  <div class="flexRowNoWrapCenter docMargins" style="background-color: xxxlightgoldenrodyellow;">
    <!-- <PersonDocumentTable></PersonDocumentTable> -->
    <DocComponent v-if="myPersonInfo != null" 
      :PersonId="personIdFromInfo"
      :EnableSearching="enableSearching"
      :ContractId="contractIdFromInfo">
    </DocComponent>    
  </div>

  <ModalBootstrap ModalId="modalConfirmStatusChange" ModalTitle="Changing Status for this Person" ButtonText="" ref="modalConfirmStatusChange" aria-label="Change Status">

    <template v-slot:body>
      <div class="alert alert-warning">Are you sure you want to change the status of this person to <span style="font-weight:bold;">{{ confirmModalText }}</span>?</div>
      <p>Clicking the Confirm button below will change the status of this person and then return to the Process Master List Page.</p>
    </template>

    <template v-slot:footer>

      <button type="button" class="btn btn-secondary" @click="this.$refs.modalConfirmStatusChange.HideModal();">Cancel</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" @click="UpdateStatus(confirmModalText)">Confirm</button>

    </template>
  </ModalBootstrap>
</template> 
  
<script> 

  import RouterLinkButton from '../helpers/RouterLinkButton.vue';
  import EditPersonForm from './EditPersonForm.vue';
  import PersonDocumentTable from './PersonDocumentTable.vue';
  import PersonWeaponTable from './PersonWeaponTable.vue';
  import PersonInfoComponent from './PersonInfoComponent.vue';
  import DocComponent from "@/components/dataSupport/DocCmp.vue";
  import {ajaxGetAndReturn} from "@/components/helpers/utilities.js"; 
  import { store } from "@/store/store.js";
  import ModalBootstrap from '@/components/dataSupport/ModalBootstrap.vue';
  import $ from "jquery";

  export default {
    name: "EditPersonPage",
    components: {
      EditPersonForm,
      PersonDocumentTable,
      PersonWeaponTable,
      RouterLinkButton,
      PersonInfoComponent, 
      DocComponent,
      ModalBootstrap
    }, 
    data(){
      return{
        isMounted : false,
        myPersonInfo:null,
        store,
        personIdFromInfo: null,
        contractIdFromInfo: null,
        headerText: "Arming, Security, and Documents for Person",
        confirmModalText:"",
        enableSearching: false,

      }
    },
    computed:{
      personId(){
        var computedValue = 0; 

        if(this.store.tempPersonId != 0){
          computedValue = this.store.tempPersonId;
        }
        else{
          computedValue = this.$route.params.personId;
        }

        return computedValue;
      }
    },
    created(){ // called BEFORE rendering (load data here)

      // console.log("creating person edit page");
      ajaxGetAndReturn(store.webAPIUrl + "personContractInfo/" + this.personId, (result) =>
      {
          this.myPersonInfo = result; 

          // console.log('###!!!>>> this.myPersonInfo = ', this.myPersonInfo);
          // console.log('myPersonInfo.contractId = ', this.myPersonInfo.contractId);

          this.$data.personIdFromInfo = this.myPersonInfo.personId;
          this.$data.contractIdFromInfo = this.myPersonInfo.contractId;
          // console.log('---->>> Computed: this.$data.personIdFromInfo = ', this.$data.personIdFromInfo);

          // console.log("lkdsajf",this.myPersonInfo);
          if(this.myPersonInfo.armStatDisplay == "QC"){
            this.headerText = "Quality Control for Person Documents";
          }
      });
    },
    mounted() { // called afer rendering
      this.isMounted = true; 
    },

    methods:{
      PersonUpdate(){

      },
      ShowStatusChangeConfirmModal(newStatus){
        this.confirmModalText = newStatus;
        this.$refs.modalConfirmStatusChange.ShowModal();
      },
      UpdateStatus(newStatus){
        // console.log("update person to ", newStatus, " status");
        var statusId = 0; 
        if(newStatus == "complete") statusId = 10; 
        if(newStatus == "hold") statusId = 11; 

        this.myPersonInfo.armingStatusId = statusId; 
        $.ajax({
            method: "PUT",
            data: JSON.stringify(this.myPersonInfo),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            url: store.webAPIUrl + "People/putPersonDto/" + this.personId,
            success: (result) => {
                result;
                //var successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
                //console.log(successMessage);
                ajaxGetAndReturn(store.webAPIUrl + "people/GetContractPersonEdit/" + this.personId, (result) =>{
                  // console.log("updated person status...");
                  this.$router.push({ name: 'processMasterList' });
                });
            },
        });
      }
    },
    unmounted(){ //called when the page is left or the component is destroyed

      //console.log("force update user contracts table"); 
      this.$forceUpdate();
    }
  }
</script>
  
<style scoped>

.flexRowNoWrapCenter {
  display: flex;
  flex-direction:column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

.docMargins {
  margin-left: 0%;
  margin-right: 0%;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 50px;
  padding-top: 20px;
}

</style>
